import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%20abstract%20illustration%20with%20warm%20orange%20red%20coral%20and%20cream%20gradient%20waves%2C%20soft%20geometric%20comic%20panel%20patterns%2C%20dynamic%20energy%20lines%2C%20modern%20minimalist%20design%2C%20playful%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-comic-01&orientation=landscape"
        alt="土豪漫画 - 海量韩漫日漫国漫免费在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium mb-6">
            <i className="ri-fire-fill"></i>
            <span>每日更新 · 海量漫画免费看</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
            海量韩漫日漫国漫
            <br />
            <span className="text-accent-300">全部免费在线阅读</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            土豪漫画网 —— 韩漫、日漫、国漫分类大全，热门漫画一应俱全。
            按类型快速找到你想看的漫画，下拉式流畅阅读体验，随时随地畅享漫画世界。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
            >
              <i className="ri-book-read-line mr-2"></i>开始阅读
            </Link>
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 text-sm font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap text-center"
            >
              <i className="ri-grid-line mr-2"></i>浏览分类
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-300">30,000+</div>
              <div className="text-xs text-background-50/60 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-300">50万+</div>
              <div className="text-xs text-background-50/60 mt-1">日活跃用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-300">全免费</div>
              <div className="text-xs text-background-50/60 mt-1">无限制畅读</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}